import AuthService from '../../services/auth.service';

const localStorageUser = JSON.parse(localStorage.getItem('user'));

const state = () => ({
  isLoggedIn: localStorageUser ? true : false,
  user: localStorageUser ? localStorageUser : null,
  showAdminPanel:
    localStorageUser != null &&
    localStorageUser.permissions != null &&
    localStorageUser.permissions.includes('Front office user management')
      ? true
      : false,
  modalErrorMessage: '',
  hasModalError: false,
  env: localStorageUser
    ? Number.parseInt(
        JSON.parse(Buffer.from(localStorageUser.token.split('.')[1], 'base64'))
          .env
      )
    : 0,
  customerPortalName: '',
  isFomoViewer:
    localStorageUser != null &&
    localStorageUser.roles != null &&
    localStorageUser.roles
      .map((r) => {
        return r.name;
      })
      .join(',')
      .includes('Subi viewer')
      ? true
      : false,
  isFomoResearcher:
    localStorageUser != null &&
    localStorageUser.roles != null &&
    localStorageUser.roles
      .map((r) => {
        return r.name;
      })
      .join(',')
      .includes('Subi Researcher')
      ? true
      : false,
});

const getters = {
  isLoggedIn: (state) => {
    return state.isLoggedIn;
  },
};

const actions = {
  login({ commit }, user) {
    return AuthService.login(user).then(
      (user) => {
        commit('loginSuccess', user);
        return Promise.resolve(user);
      },
      (error) => {
        commit('loginFailure');
        return Promise.reject(error);
      }
    );
  },
  logout({ commit }) {
    AuthService.logout();
    commit('logout');
  },
};

const mutations = {
  setCustomerPortalName(state, val) {
    state.customerPortalName = val;
  },
  setEnvironment(state, val) {
    state.env = val;
  },
  loginSuccess(state, user) {
    state.isLoggedIn = true;
    state.user = user;
    if (user.permissions.includes('Front office user management'))
      state.showAdminPanel = true;
    if (
      user.roles
        .map((r) => {
          return r.name;
        })
        .join(',')
        .includes('Subi viewer')
    )
      state.isFomoViewer = true;
  },
  loginFailure(state) {
    state.isLoggedIn = false;
    state.user = null;
  },
  logout(state) {
    state.isLoggedIn = false;
    state.user = null;
    state.showAdminPanel = false;
    state.isFomoViewer = false;
  },
  resetModalError(state) {
    state.modalErrorMessage = '';
  },

  enableModalError(state) {
    state.hasModalError = true;
  },
  disableModalError(state) {
    state.hasModalError = false;
  },
  updateModalError(state, message) {
    state.modalErrorMessage = message;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
